import type { ElementType } from 'react'
import { NotAllowedPage } from '~/modules/navigation/views'

type Props = {
  component: ElementType
  canAccess?: boolean
}

export const AuthWrapped = ({ canAccess = false, component: Component, ...props }: Props) =>
  canAccess ? <Component {...props} /> : <NotAllowedPage />
